import Agent from '../Core/agent';

const headers = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};

const OrderAPi = {
    create: data => {
        return Agent.post('/api/v1/order/create',  data);
    }
};
export default OrderAPi;